// Формат почты (принцип XVI; 005: FR-013): одно правило для сервера (DIR-001) и для интерфейса —
// ошибка под полем исчезает, когда значение стало верным (ux.md, раздел 13). Имя@домен.зона:
// без пробелов и знаков, которых в адресе не бывает; части домена не пустые; зона — только
// буквы, от 2 знаков («ru», «рф»), или запись IDN «xn--…». Зон с цифрами нет: «ru1» — опечатка.
export const EMAIL_MAX = 254;

const EMAIL = /^[^\s@,;<>()"]+@(?:[^\s@,;<>()".]+\.)+(?:\p{L}{2,63}|xn--[a-z\d-]{2,59})$/iu;

/** Адрес почты по формату; пробелы по краям не мешают. */
export function isEmailAddress(text: string): boolean {
  const value = text.trim();
  return value.length <= EMAIL_MAX && EMAIL.test(value);
}
